// This is a simple polyfill for URL in the browser environment
// The browser already has URL implementation, so we just export it

// For react-native-web compatibility
export default {
  URL: typeof window !== 'undefined' ? window.URL : null,
  URLSearchParams:
    typeof window !== 'undefined' ? window.URLSearchParams : null,
};

// For direct imports
export const URL = typeof window !== 'undefined' ? window.URL : null;
export const URLSearchParams =
  typeof window !== 'undefined' ? window.URLSearchParams : null;
